import { render, staticRenderFns } from "./ElementPeriodResultTableColumn.vue?vue&type=template&id=34863987&scoped=true"
import script from "./ElementPeriodResultTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementPeriodResultTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementPeriodResultTableColumn.vue?vue&type=style&index=0&id=34863987&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34863987",
  null
  
)

export default component.exports